export const styles = {
  header: {
    background: " #ECECEC",
    borderRadius: "6px 6px 0px 0px",
    padding: "15px 20px",
  },
  title: {
    background: "#FFFFFF",
    borderRadius: "10px",
    padding: "10px",
  },
  email: {
    padding: "10px 20px",
  },
  edit: {
    background: "#fff",
  },
};
